import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit, OnChanges {

  @Output() pageChange = new EventEmitter<number>();

  pages:number[] = [];

  //@Input()
  pagesSize : number = 7;

  @Input() currentPage : number = 1;

  @Input() pageSize : number = 1;
  @Input() total : number = 1;
  totalPages : number = 1;
  constructor() { }

  ngOnChanges(){
    this.updatePages();
  }

  ngOnInit(): void {  }

  changePage(page: number, i : number){
    let currentPage = page === -1 ? ( i === 1 ? this.pages[Math.floor(this.pagesSize / 2)] - 2 : this.pages[Math.floor(this.pagesSize / 2)] + 2) : page;
    this.updatePages();
    this.pageChange.emit(currentPage);
  }
  
  updatePages(){
    this.pages = [];
    this.totalPages = Math.ceil(this.total/this.pageSize);

    if(this.pagesSize < this.totalPages){
      this.pages = [1,-1,this.currentPage-1,this.currentPage,this.currentPage+1,-1,this.totalPages]
      if(this.currentPage < 5){
        this.pages = [1,2,3,4,5,-1,this.totalPages];
      }
      if(this.currentPage > (this.totalPages - 5)){
        this.pages = [1,-1,this.totalPages-4,this.totalPages-3,this.totalPages-2,this.totalPages-1,this.totalPages];
      }
    }
    else{
      for(let i = 1; i <= this.totalPages; i++){
        this.pages.push(i);
      }
    }

  }
}
